var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", "no-margin": "" } },
            [
              _c("w-select", {
                attrs: {
                  label: _vm.$ct("operator"),
                  fancy: "",
                  items: _vm.operators,
                },
                model: {
                  value: _vm.value.Operator,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Operator", $$v)
                  },
                  expression: "value.Operator",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", "no-margin": "" } },
            [
              _c("w-input-number", {
                attrs: {
                  value: _vm.numValue,
                  label: _vm.$ct("single-value"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.onInputValue($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }